import { SectionGroup } from '@sleepstation/components'
import { VLayout } from '@sleepstation/components-layouts'
import { CopyRenderer } from '@sleepstation/components-markdown-renderer'
import { LAYOUT_SPACING } from '@sleepstation/const'
import { parseToAst } from '@sleepstation/markdown'
import { mq } from '@sleepstation/style-api-helpers'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import PortalLinks from '../../../../shared/portal/PortalLinks'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({ spacing: LAYOUT_SPACING.X_LARGE })`
  ${mq(`mediumUp`)} {
    > *:first-child {
      max-width: 65.1%;
    }
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const LinkPreview = ({ title, body, links }) => {
  const bodyAst = parseToAst(body)
  return (
    <Layout>
      <SectionGroup title={title} spacing={[0.5, 1]}>
        <CopyRenderer htmlAst={bodyAst} />
      </SectionGroup>
      <PortalLinks links={links} />
    </Layout>
  )
}

LinkPreview.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  links: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default LinkPreview
